import { useCallback } from 'react';
import timerOutSound from '../../../../assets/sounds/timer_out.mp3';
import multiplyUpSound from '../../../../assets/sounds/multiply_up.mp3';
import multiplyDownSound from '../../../../assets/sounds/multiply_down.mp3';

const useSound = (soundsEnabled = true) => {
  const sounds = {
    timerOut: new Audio(timerOutSound),
    multiplyUp: new Audio(multiplyUpSound),
    multiplyDown: new Audio(multiplyDownSound),
  };

  const playSound = useCallback(
    (soundType) => {
      if (!soundsEnabled) return;

      try {
        const soundToPlay = sounds[soundType];
        if (soundToPlay) {
          soundToPlay.currentTime = 0;
          soundToPlay.play();
        }
      } catch (e) {
      }
    },
    [soundsEnabled, sounds]
  );

  return playSound;
};

export default useSound;
